import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";

const GuestAuthContext = createContext(null);

export const GuestAuthProvider = ({ children }) => {
  const [guest, setGuest] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("atlas_guest_token");
    if (!token) { setLoading(false); return; }
    api.get("/guest/me", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setGuest(r.data))
      .catch(() => localStorage.removeItem("atlas_guest_token"))
      .finally(() => setLoading(false));
  }, []);

  const register = async (name, email, password, phone) => {
    const res = await api.post("/guest/register", { name, email, password, phone });
    localStorage.setItem("atlas_guest_token", res.data.token);
    setGuest(res.data.guest);
    return res.data.guest;
  };

  const login = async (email, password) => {
    const res = await api.post("/guest/login", { email, password });
    localStorage.setItem("atlas_guest_token", res.data.token);
    setGuest(res.data.guest);
    return res.data.guest;
  };

  const logout = () => {
    localStorage.removeItem("atlas_guest_token");
    setGuest(null);
  };

  return (
    <GuestAuthContext.Provider value={{ guest, loading, register, login, logout }}>
      {children}
    </GuestAuthContext.Provider>
  );
};

export const useGuestAuth = () => useContext(GuestAuthContext);

// Helper to get guest token for API calls
export const guestApi = () => {
  const token = localStorage.getItem("atlas_guest_token");
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
